export default __webpack_public_path__ + "static/media/automatskavrata11.b24191cd.jpg";